import { useForm, type UseFormProps, type FieldValues } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { type z } from "zod";

/**
 * Thin wrapper around useForm that wires up zodResolver automatically.
 * Usage:
 *   const form = useZodForm(MySchema, { defaultValues: { ... } });
 */
export function useZodForm<
  TOut extends FieldValues,
  TSchema extends z.ZodType<TOut>,
>(
  schema: TSchema,
  options?: Omit<UseFormProps<TOut>, "resolver">,
) {
  return useForm<TOut>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(schema as any),
    ...options,
  });
}
